module.exports = __webpack_public_path__ + "img/velador.932e5c03.svg";